// extracted by mini-css-extract-plugin
export default {"form":"CardNameEdit_form__pONFM","field":"CardNameEdit_field__2vjwY","buttons":"CardNameEdit_buttons__6-RSA"};